import * as React from 'react';

export default (
  <svg height="16" viewBox="0 0 16 16" width="16">
    <path
      d="m1330 268.592486h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42s1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6c-.18683-.187253-.44048-.292486-.705-.292486s-.51817.105233-.705.292486c-.39.39-.39 1.02 0 1.41l4.87 4.89h-11.17c-.55 0-1 .45-1 1s.45 1 1 1z"
      fill="#0070f0"
      fillRule="evenodd"
      transform="translate(-1329 -260)"
    />
  </svg>
);
